export function intersectArrays<T>(...arrays: T[][]): T[] {
    if (arrays.length === 0) return [];

    arrays.sort((a, b) => a.length - b.length);
    const [first, ...rest] = arrays;
    const result: T[] = [];
    const seen = new Set<T>();
    const sets = rest.map((arr) => new Set(arr));

    for (const value of first) {
        if (!seen.has(value) && sets.every((set) => set.has(value))) {
            seen.add(value);
            result.push(value);
        }
    }

    return result;
}

export function limitArrayDisplay(items: string[], maxItems: number = 2): string {
    if (items.length <= maxItems) {
        return items.join(', ');
    }
    const displayed = items.slice(0, maxItems).join(', ');
    return `${displayed} ...`;
}

function multiSelectValueKey(value: unknown): string {
    if (value == null) return '';
    if (!Array.isArray(value)) return String(value);
    return [...value].map(String).sort().join(',');
}

export function hasMultiSelectValueChanged(prev: unknown, next: unknown): boolean {
    return multiSelectValueKey(prev) !== multiSelectValueKey(next);
}
